import { useState } from "react";
import { Mic } from "@safers/ui/atoms";
import { useCommandSubmit } from "@/hooks/useCommandSubmit";
import { useCommandModalStore, selectOpenCommandModal } from "@/stores";

export function HeaderCommandSearch() {
  const [value, setValue] = useState("");
  const { submit, isSubmitting } = useCommandSubmit();
  const openCommand = useCommandModalStore(selectOpenCommandModal);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    submit(value);
    setValue("");
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="group flex h-9 w-64 items-center gap-2 rounded-xl bg-white px-3.5"
    >
      <input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        disabled={isSubmitting}
        placeholder="Safers AI 에게 물어보기…"
        aria-label="Safers AI 명령 입력"
        className="min-w-0 flex-1 bg-transparent text-sm text-neutral-700 outline-none placeholder:text-neutral-400 disabled:opacity-60"
      />
      {isSubmitting ? (
        <span
          className="h-3.5 w-3.5 shrink-0 animate-spin rounded-full border-2 border-neutral-200 border-t-brand"
          aria-label="처리 중"
        />
      ) : (
        <button
          type="button"
          onClick={openCommand}
          aria-label="음성 명령 모달 열기"
          className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-neutral-400 transition-colors hover:bg-neutral-100 hover:text-brand"
        >
          <Mic size="sm" />
        </button>
      )}
    </form>
  );
}
